import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { getViewOptions } from 'src/models/TaskViewOptions';
import { MenuItem, IconMenu, IconButton, FontIcon } from 'material-ui';
import { grey600 } from 'material-ui/styles/colors';
import { getTaskTypeOptions } from '../../models/TaskTypeOptions';
var styles = {
    form: {
        margin: '15px 20px',
        padding: '0px 10px',
        backgroundColor: 'white',
        borderRadius: '5px',
        border: '1px solid #e0e0e0',
        display: 'flex'
    },
    input: {
        width: '100%',
        fontSize: '12px',
        outline: 'none',
        border: 'none',
        height: '35px',
        borderRight: '1px solid #e0e0e0',
        padding: '0px 5px',
    },
    inputSmall: {
        width: '100%',
        fontSize: '12px',
        height: '35px',
        outline: 'none',
        border: 'none',
        lineHeight: '35px',
        borderBottom: '1px solid #e0e0e0',
        padding: '0px 5px',
    },
    toggle: {
        fontSize: '11px',
        width: '120px',
        color: 'white',
        textAlign: 'center',
        margin: '.5rem',
        borderRadius: '5px',
        cursor: 'pointer'
    }
};
var TaskFilter = /** @class */ (function (_super) {
    tslib_1.__extends(TaskFilter, _super);
    function TaskFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.onPreferencesChanged = function () {
            var filter = _this.props.taskStore.filter;
            var preferences = _this.props.preferencesStore;
            filter.viewOption = preferences.cardViewFilter.value;
            _this.forceUpdate();
        };
        _this.handleChange = function (key, event) {
            event.preventDefault();
            _this.props.taskStore.filter.setValue(key, event.target.value);
        };
        _this.handleViewFilterChange = function (e, value) {
            e.preventDefault();
            _this.props.taskStore.filter.setValue('viewOption', value);
        };
        return _this;
    }
    TaskFilter.prototype.componentWillMount = function () {
        this.props.taskStore.filter.viewOption = this.props.preferencesStore.cardViewFilter.value;
    };
    TaskFilter.prototype.componentDidMount = function () {
        this.props.preferencesStore.changed.subscribe(this.onPreferencesChanged);
    };
    TaskFilter.prototype.componentWillUnmount = function () {
        this.props.preferencesStore.changed.unsubscribe(this.onPreferencesChanged);
    };
    Object.defineProperty(TaskFilter.prototype, "filter", {
        get: function () {
            return this.props.taskStore.filter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaskFilter.prototype, "formStyle", {
        get: function () {
            return this.props.preferencesStore.hasSmallScreen
                ? tslib_1.__assign({}, styles.form, { flexDirection: 'column' })
                : styles.form;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaskFilter.prototype, "inputStyle", {
        get: function () {
            return this.props.preferencesStore.hasSmallScreen
                ? styles.inputSmall
                : styles.input;
        },
        enumerable: true,
        configurable: true
    });
    TaskFilter.prototype.render = function () {
        var _this = this;
        if (!this.props.preferencesStore.taskFilterVisible.value) {
            return null;
        }
        var employeeFilter = this.renderEmployeeFilter();
        var userFilter = this.renderUserFilter();
        return (React.createElement("form", { style: this.formStyle, className: "form-inline" },
            employeeFilter,
            React.createElement("select", { value: this.filter.typeOption, style: tslib_1.__assign({}, this.inputStyle, { maxWidth: '125px', textAlign: 'center' }), onChange: function (e) { return _this.handleChange('typeOption', e); } }, getTaskTypeOptions().map(function (o) { return React.createElement("option", { key: o, value: o }, o); })),
            React.createElement("input", { placeholder: "Keres\u00E9s", value: this.filter.fullTextSearch, style: this.inputStyle, onChange: function (e) { return _this.handleChange('fullTextSearch', e); } }),
            React.createElement("input", { placeholder: "\u00DCtem (Ticket)", value: this.filter.stepName, style: this.inputStyle, onChange: function (e) { return _this.handleChange('stepName', e); } }),
            userFilter,
            React.createElement("input", { placeholder: "Projekt", value: this.filter.projectName, style: this.inputStyle, onChange: function (e) { return _this.handleChange('projectName', e); } }),
            React.createElement("input", { placeholder: "M\u0171velet", value: this.filter.competencyName, style: this.inputStyle, onChange: function (e) { return _this.handleChange('competencyName', e); } }),
            React.createElement("input", { placeholder: "St\u00E1tusz", value: this.filter.statusName, style: this.inputStyle, onChange: function (e) { return _this.handleChange('statusName', e); } }),
            React.createElement("input", { placeholder: "Priorit\u00E1s", value: this.filter.priority, style: this.inputStyle, onChange: function (e) { return _this.handleChange('priority', e); } }),
            React.createElement("input", { placeholder: "C\u00EDmkefelh\u0151", value: this.filter.tagCloud, style: this.inputStyle, onChange: function (e) { return _this.handleChange('tagCloud', e); } }),
            React.createElement("input", { placeholder: "Megnevez\u00E9s", value: this.filter.title, style: this.inputStyle, onChange: function (e) { return _this.handleChange('title', e); } }),
            React.createElement("input", { placeholder: "Le\u00EDr\u00E1s", value: this.filter.description, style: this.inputStyle, onChange: function (e) { return _this.handleChange('description', e); } })));
    };
    TaskFilter.prototype.renderUserFilter = function () {
        var _this = this;
        if (!this.props.userStore.loggedInUserIsAdmin) {
            return null;
        }
        return (React.createElement("input", { placeholder: "V\u00E9grehajt\u00F3", value: this.filter.userName, style: this.inputStyle, onChange: function (e) { return _this.handleChange('userName', e); } }));
    };
    TaskFilter.prototype.renderEmployeeFilter = function () {
        if (!this.props.userStore.loggedInUserIsAdmin) {
            return null;
        }
        var selectedViewOption = this.props.taskStore.filter.viewOption;
        var viewOptions = getViewOptions();
        var items = viewOptions.map(function (i) { return React.createElement(MenuItem, { key: i, value: i, primaryText: i }); });
        var icon = (React.createElement(IconButton, { style: { height: 'auto', width: 'auto', padding: 0, margin: '5px 5px 0 0' } },
            React.createElement(FontIcon, { color: grey600, className: "material-icons" }, "filter_list")));
        return (React.createElement(IconMenu, { value: selectedViewOption, iconButtonElement: icon, onChange: this.handleViewFilterChange, children: items }));
    };
    TaskFilter = tslib_1.__decorate([
        inject('preferencesStore', 'userStore', 'taskStore'),
        observer
    ], TaskFilter);
    return TaskFilter;
}(React.Component));
export { TaskFilter };



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskFilter.tsx
// module id = 730
// module chunks = 0